var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("管理员权限页面")]),_c('p',[_vm._v("只有用 admin 账号登录的才拥有管理员权限，才能进到这个页面，其他账号想进来都会跳到403页面，重新用管理员账号登录才有权限。")]),_c('p',[_vm._v("想尝试一下，请"),_c('router-link',{staticClass:"logout",staticStyle:{"color":"#409EFF"},attrs:{"to":"/login"}},[_vm._v("退出登录")]),_vm._v("，随便输入个账号名，再进来试试看。")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }